import { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';

import { TranslationService } from '@/utils/services/TranslationService';

import useUser from '@/utils/hooks/swr/useUser';

import useRouterQuery from '@/utils/hooks/utils/useRouterQuery';

import { SUBSCRIPTION_INVOICES } from '@/lib/routes/privateRoutes';

import { WrapperSwitchLayout } from '@/components/layouts/wrappers/WrapperSwitchLayout';
import { Content } from '@/components/pages/settings/subscription-invoices/PageContent';
import SettingsWrapper from '@/components/layouts/LayoutPlatform/components/SettingsWrapper';

const PricingModal = dynamic(() =>
    import('@/components/pages/settings/subscription-invoices/PlanModal').then(
        (el) => el.PricingModal
    )
);

const PageContent = () => {
    const [isOpenPlanModal, setIsOpenPlanModal] = useState(false);
    const { user } = useUser();
    const router = useRouter();
    const { clearUrlQueriesWithoutReload } = useRouterQuery();
    const { step } = router.query;

    const togglePlanModal = () => {
        setIsOpenPlanModal((isOpen) => !isOpen);
    };

    useEffect(() => {
        if (!step || step !== 'change_your_plan' || user.past_due) {
            return;
        }
        if (isOpenPlanModal) {
            return;
        }

        // Using setTimeout to delay URL query clearing
        // This prevents state update conflicts that were causing the modal to close immediately
        setTimeout(() => {
            clearUrlQueriesWithoutReload();
        }, 100);

        // Set modal state directly rather than calling togglePlanModal
        // Makes the code flow more predictable
        setIsOpenPlanModal(true);
    }, [step]);

    return (
        <SettingsWrapper>
            <Content togglePlanModal={togglePlanModal} />
            {/* Using closePlanModal instead of togglePlanModal for more predictable behavior */}
            <PricingModal isOpen={isOpenPlanModal} toggle={togglePlanModal} />
        </SettingsWrapper>
    );
};

const SubscriptionInvoices = () => (
    <WrapperSwitchLayout noPadding={true} disableMainScroll={true}>
        <PageContent />
    </WrapperSwitchLayout>
);

export const getServerSideProps =
    TranslationService.getTranslationMessagesFromRoute(SUBSCRIPTION_INVOICES);

export default SubscriptionInvoices;
